import { spacingFn } from '@britishcouncil/react-extro-ui/dist/theme/utils/spacingFn';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonLoader = () => {
  return (
    <>
      <Skeleton count={2} height={spacingFn(7)} />
      <Skeleton count={3} height={spacingFn(7)} />
      <Skeleton count={1} height={spacingFn(7)} />
    </>
  );
};

export default SkeletonLoader;
